import React from "react";
import "./conversations.scss";

const ErrorMessage = ({
  summary,
  detail,
  handleClose,
  otherAction,
  handleOtherAction,
}) => {
  return (
    <div className="attachment__error">
      <div>
        <i className={`pi pi-times-circle error__timer--icon`} />
        <div>
          <span className="attachment__error--summary">{summary}</span>
          <span className="attachment__error--detail">{detail}</span>
          {otherAction && (
            <span
              className="attachment__error--other"
              onClick={handleOtherAction}
            >
              {otherAction}
            </span>
          )}
        </div>
      </div>
      <i className={"pi pi-times error__close--icon"} onClick={handleClose} />
    </div>
  );
};

export default ErrorMessage;
